import _ from 'lodash'
import moment from 'moment'

export default {

  extractTestimoniesMarkers (testimonies, linkToDetails = false) {
    let markers = []
    if (testimonies && testimonies.length) {
      markers = _.compact(testimonies.map(testimony => this.extractTestimonyMarker(testimony, linkToDetails)))
    }
    return markers
  },

  extractTestimonyMarker (testimony, linkToDetails = false) {
    const longitude = _.get(testimony, 'victimLocation.geoLocation.coordinates[0]')
    const latitude = _.get(testimony, 'victimLocation.geoLocation.coordinates[1]')

    if (_.isNumber(longitude) && _.isNumber(latitude)) {
      const marker = {
        title: `Testimony #${testimony.randomId}`,
        coordinates: {latitude, longitude},
        perimeter: null,
        popup: this.buildTestimonyPopupDescription(testimony)
      }

      if (linkToDetails) {
        marker.link = {
          label: 'View details',
          route: {
            name: 'Testimony',
            params: {id: testimony._id || testimony.id}
          }
        }
      }

      return marker
    } else {
      return null
    }
  },

  buildTestimonyPopupDescription (testimony) {
    const creationDate = testimony.creationDate ? moment(testimony.creationDate).format('MM/DD/YYYY HH:mm') : 'Unknown'

    let identity = testimony.fullName
    if (!identity) {
      const firstname = _.get(testimony, 'identity.firstName', '')
      const lastname = _.get(testimony, 'identity.name', '')
      identity = (firstname || lastname) ? `${firstname} ${lastname}`.trim() : 'Unknown'
    }

    const gender = _.get(testimony, 'identity.gender', '')
    let genderIcon
    switch (gender) {
      case 'MALE':
        genderIcon = 'mars'
        break
      case 'FEMALE':
        genderIcon = 'venus'
        break
      default:
        genderIcon = 'genderless'
    }

    let attackDate = null

    if (testimony.actionPeriod) {
      const startMoment = moment(testimony.actionPeriod.startTime)
      const endMoment = moment(testimony.actionPeriod.endTime)

      if (startMoment.isSame(endMoment)) {
        attackDate = endMoment.format('MM/DD/YYYY HH:mm')
      } else if (startMoment.isSame(endMoment, 'day')) {
        attackDate = `${endMoment.format('MM/DD/YYYY')} between <br>${startMoment.format('HH:mm')} and ${endMoment.format('HH:mm')}`
      } else if (startMoment.isSame(endMoment, 'month')) {
        attackDate = `${endMoment.format('MMM YYYY')} between <br>${startMoment.format('Qo')} and ${endMoment.format('Qo')}`
      } else {
        attackDate = `between ${startMoment.format('MM/DD/YYYY')} and ${endMoment.format('MM/DD/YYYY')}`
      }

      if (!testimony.actionPeriod.exactTime && !testimony.actionPeriod.exactDate) {
        attackDate += `&nbsp;<i class="fa fa-exclamation text-danger" title="Estimated time" data-toggle="tooltip" data-placement="top"></i>`
      }
    }

    const hasInjury = _.get(testimony, 'victimCondition.injury', false)
    const injured = (hasInjury) ? 'Injured' : 'Not injured'

    return `
      <strong>Testimony #${testimony.randomId}</strong><br>
      <i class="fa fa-fw fa-clock"></i>&nbsp;${creationDate}<br>
      <i class="fa fa-fw fa-${genderIcon}" title="${_.startCase(_.lowerCase(gender))}"></i>&nbsp;${identity}<br>
      <br><strong>Attack</strong><br>
      <i class="fa fa-fw fa-calendar-day"></i>&nbsp;${_.defaultTo(attackDate, '(date not specified)')}<br>
      <i class="fa fa-fw fa-user-injured"></i>&nbsp;${injured}
    `
  }
}



// WEBPACK FOOTER //
// ./src/helper.js